import React, { useEffect, useState } from 'react'
import services from '../../services'
import { formatar, Indicador, pontosDaLinha, variacao } from './indicador'

const LARGURA = 120
const ALTURA = 30

/** O indicador no card do favorito: valor desta semana, variação e as 12 semanas. Some quando não há indicador. */
export default function IndicadorDoCard({ dashboardId, ambienteId }: { dashboardId: number; ambienteId: number }) {
  const [ind, setInd] = useState<Indicador | null | undefined>(undefined)

  useEffect(() => {
    let vale = true
    services.api.novoPortalIndicador(dashboardId, ambienteId).then((r: any) => {
      if (vale) setInd(r.fail || r.status === 204 || !r.data ? null : r.data)
    })
    return () => { vale = false }
  }, [dashboardId, ambienteId])

  if (ind === undefined) return <span className="ni-ind carregando" aria-hidden="true" />
  if (ind === null) return null
  if (ind.semValorNaRegra) return <span className="ni-ind"><small>Sem valor na regra deste dashboard</small></span>

  const v = variacao(ind)
  const pontos = pontosDaLinha(ind.serie, LARGURA, ALTURA)
  return (
    <span className="ni-ind" title={`${ind.medida} nos últimos 7 dias, comparado aos 7 anteriores`}>
      <span className="ni-ind-num">
        <strong>{formatar(ind.valor, ind.formato)}</strong>
        {v && <em className={v.bom == null ? '' : v.bom ? 'bom' : 'ruim'}>{v.texto}</em>}
        <small>{ind.medida} · 7 dias</small>
      </span>
      {pontos && (
        <svg className="ni-ind-linha" width={LARGURA} height={ALTURA} viewBox={`0 0 ${LARGURA} ${ALTURA}`} role="img" aria-label={`${ind.medida} nas últimas 12 semanas`}>
          <polyline points={pontos} fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
        </svg>
      )}
    </span>
  )
}
